var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "survey-container" },
    [
      _vm.surveyCompleted
        ? _c(
            "div",
            { staticClass: "survey-completed mt-3" },
            [
              _c(
                "b-col",
                { staticClass: "mx-auto centered", attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    [
                      _c("base-icon", {
                        attrs: {
                          width: "100px",
                          height: "100px",
                          src: "/static-appopensalud/img/icons/full.png",
                          color: "blue"
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("h5", { staticClass: "text-center mt-5" }, [
                        _vm._v(_vm._s(this.$i18n.t("surveys.completed2")))
                      ]),
                      _vm._v(" "),
                      _vm.fromDialog
                        ? _c("p", { staticClass: "text-center mt-5" }, [
                            _vm._v(_vm._s(this.$i18n.t("surveys.close-dialog")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showOpenSaludButton
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mt-5",
                              attrs: { variant: "primary", block: "" },
                              on: { click: _vm.goToOpenSalud }
                            },
                            [
                              _vm._v(
                                _vm._s(this.$i18n.t("surveys.opensalud-go")) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { staticClass: "mt-3", attrs: { name: "fade", mode: "out-in" } },
        [
          !_vm.loading && !_vm.surveyCompleted && _vm.items.length > 0
            ? _c("div", { staticClass: "survey-step" }, [
                !_vm.started
                  ? _c("h2", { staticClass: "text-center mb-5" }, [
                      _vm._v(
                        _vm._s(_vm.$i18nHelpers.normalize(_vm.surveyTitle))
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.started
                  ? _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "primary" },
                            on: { click: _vm.handleSurveyStart }
                          },
                          [_vm._v(_vm._s(this.$i18n.t("surveys.start")))]
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c(
                          "div",
                          { staticClass: "progress-container" },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.progressPercentage) +
                                  _vm._s(
                                    this.$i18n.t("surveys.percentage-completed")
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-progress",
                              { staticClass: "progress-bar" },
                              [
                                _c("b-progress-bar", {
                                  staticClass: "progress-bar-inner",
                                  attrs: {
                                    value: _vm.progressPercentage,
                                    max: 100
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("question-card", {
                          attrs: {
                            labelsEnabled: "",
                            question: _vm.question,
                            progress: _vm.answeredItems.size,
                            questionnaireLength: _vm.items.length,
                            fullWidthCard: ""
                          },
                          on: {
                            answerQuestion: _vm.saveCurrentAnswer,
                            submitQuestionnaire: function() {}
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "additionalComment",
                                fn: function() {
                                  return [
                                    _c(
                                      "b-form-group",
                                      { staticClass: "mt-3" },
                                      [
                                        _vm.responses[_vm.currentItem.id]
                                          ? _c("b-form-textarea", {
                                              attrs: {
                                                rows: "2",
                                                "max-rows": "4",
                                                placeholder: _vm.$i18n.t(
                                                  "surveys.comment-review"
                                                ),
                                                "no-resize": ""
                                              },
                                              model: {
                                                value:
                                                  _vm.responses[
                                                    _vm.currentItem.id
                                                  ].freeText,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.responses[
                                                      _vm.currentItem.id
                                                    ],
                                                    "freeText",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "responses[currentItem.id].freeText"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            969386706
                          ),
                          model: {
                            value: _vm.questionResult,
                            callback: function($$v) {
                              _vm.questionResult = $$v
                            },
                            expression: "questionResult"
                          }
                        })
                      ],
                      1
                    )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34d479db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d479db","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/surveys/SurveyTemplate.vue
// module id = 3154
// module chunks = 39 61